<template>
  <div>
    <v-card outlined>
      <v-card-title border class="font-size-14 font-weight-bold secondary--text">Link Website Replika Anda</v-card-title>
      <v-card-text>
        <p>Link Website Replika berfungsi sebagai alat promosi online anda, sehingga anda profesional memiliki website dengan kontak anda langsung.</p>
        <v-alert
          text
          prominent
          dense
          type="error"
          icon="mdi-alert"
          v-if="errMessage"
        >
          {{ errMessage }}
        </v-alert>
        
        <v-card outlined class="mb-3">
          <v-card-text>
            <v-row>
              <v-col cols="4" class="d-flex flex-row align-center">
                <v-icon class="mr-3">mdi-web</v-icon>
                <!-- <span class="font-weight-bold primary--text" v-if="refhost == 'https://office.shinebeautynetwork.com'">https://shinebeautynetwork.com/ref/</span>
                <span class="font-weight-bold primary--text" v-else>https://public.shinebeauty.esoftdream.co.id/ref/</span> -->
                <span class="font-weight-bold primary--text" v-if="refhost == 'https://office.shinebeautynetwork.com'">https://shinebeautynetwork.com/?ref=</span>
                <span class="font-weight-bold primary--text" v-else>https://public.shinebeauty.esoftdream.co.id/?ref=</span>
              </v-col>
              <v-col cols="6" class="px-0">
                <v-text-field
                  v-model="refcode"
                  outlined
                  hide-details="auto"
                  dense
                  :error-messages="(errorValidation !== undefined && errorValidation['referral'] !== undefined ) ? [errorValidation['referral']] : []"
                  :rules="[rules.inputreq('Kode Referral', refcode)]"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  block
                  color="primary"
                  :loading="loading"
                  style="height: 40px;"
                  @click="processSetReferral"
                >Submit</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <p>Silakan menyebarkan link Website Replika Anda sebagai alat promosi.</p>
        <p class="green--text" v-if="referral !== ''">Ke Website Replika anda Klik atau copy link berikut: <a :href="reflink" target="_blank" class="font-weight-bold">{{ reflink }}</a></p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			errMessage: null,
      refhost: window.location.origin,
      refcode: '',
      reflink: 'https://shinebeautynetwork.com/?ref=',
			loading: false,
      loadingData: false,
      rules: {
        inputreq(label, v) { 
					return !!v || label + ' harus diisi terlebih dahulu.'
				},
      }
		}
	},
	computed: {
    ...mapState('profil', ['referral', 'errorValidation']),
	},
	methods: {
		...mapActions('profil', ['getReferral', 'setReferral']),

		processSetReferral() {
      this.loading = true
			let paramsData = new FormData()
			paramsData.append('referral', this.refcode)

      this.setReferral(paramsData).then(() => {
        // console.log(response)
        this.getReferral()

				setTimeout(() => {
          this.refcode = this.referral
          if (this.refhost == 'https://office.shinebeautynetwork.com') this.reflink = 'https://shinebeautynetwork.com/?ref=' + this.refcode
          else this.reflink = 'https://public.shinebeauty.esoftdream.co.id/?ref=' + this.refcode
          this.loading = false
        }, 600);
			}).catch(() => {
				window.scrollTo(0,0)
				this.loading = false
			})
		},
	},
	created(){
    this.loadingData = true
		this.$store.dispatch('setPageTitle', `Web Replika`)
    this.getReferral()

    setTimeout(() => {
      this.refcode = this.referral
      if (this.refhost == 'https://office.shinebeautynetwork.com') this.reflink = 'https://shinebeautynetwork.com/?ref=' + this.refcode
      else this.reflink = 'https://public.shinebeauty.esoftdream.co.id/?ref=' + this.refcode
      this.loadingData = false
    }, 600);
	}
};
</script>
